import type { ImageType } from "@/types";
import Image from "./image.tsx";

type Props = { image: ImageType };
export default function Swatch({ image }: Props) {
    return (
        <div className="swatch">
            <Image image={image} />
        </div>
    );
}
